import { gt, gte, lt, lte, eq, includes } from 'lodash';
import { IConditionEvaluator } from './IConditionEvaluator';

export abstract class ConditionOnFieldEvaluator implements IConditionEvaluator {
  fieldName: string;

  protected constructor(fieldName: string) {
    this.fieldName = fieldName;
  }

  protected hasField(condition: any): boolean {
    return condition[this.fieldName];
  }

  canHandleCondition(condition: any): boolean {
    return this.hasField(condition);
  }

  abstract isMatchCondition(condition: any, data: any): boolean;
}

export const operationBuilder = {
  greaterThan: (value1, value2) => gt(value1, value2),
  greaterThanEqual: (value1, value2) => gte(value1, value2),
  lessThan: (value1, value2) => lt(value1, value2),
  lessThanEqual: (value1, value2) => lte(value1, value2),
  equal: (value1, value2) => eq(value1, value2),
  notEqual: (value1, value2) => !eq(value1, value2),
  in: (value, arr) => includes(arr, value),
};
